// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'styled-components';
import { useIconSize } from '../useIconSize';
import { jsx as _jsx } from "react/jsx-runtime";
export const SuccessIcon = ({
  size = 'inherit',
  color = 'inherit',
  'aria-label': ariaLabel,
  id
}) => {
  const theme = useTheme();
  const sizeValue = useIconSize(size);
  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // currentColor = color of the parent element

  return /*#__PURE__*/_jsx("svg", {
    width: sizeValue,
    height: sizeValue,
    fill: colorValue,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Success",
    children: /*#__PURE__*/_jsx("path", {
      d: "M27.24 6.78 12.23 21.79l-7.47-7.47A1.619 1.619 0 0 0 2 15.47c0 .45.18.85.47 1.14l8.62 8.61a1.62 1.62 0 0 0 2.28 0L29.53 9.07a1.619 1.619 0 0 0-1.15-2.76c-.45 0-.85.18-1.14.47"
    })
  });
};